import Vue from 'vue'
import Vuex from 'vuex'

import createVuexLoadingPlugin from 'vuex-plugin-loading'

import { root } from './modules/root'
import homeStore from '@/views/HomePage/store'
import ManaModeStore from '@/views/ManaMode/store'
// 系统管理
import systemManagementStore from '@/views/ManaMode/systemManagement/store'
// 设备管理
import deviceManagementStore from '@/views/ManaMode/deviceManagement/store'

Vue.use(Vuex)

const store = {
  strict: process.env.NODE_ENV !== 'production',
  ...root,
  modules: {
    homeStore,
    ManaModeStore,
    ...systemManagementStore,
    ...deviceManagementStore,
  },
  plugins: [createVuexLoadingPlugin()],
}

export default new Vuex.Store(store)
